// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input,
optgroup,
select,
textarea,
label,
a,
p {
  font-family: "Open Sans", sans-serif !important;
  color: #2f2f2f;
}

.register-container {
  background-color: white;
}

.register-container .d-flex {
  display: flex !important;
}

button {
  font-family: "Source Sans Pro", sans-serif !important;
  color: #2f2f2f;
}

.left-content,
.right-content {
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.left-content {
  width: 60%;
  position: relative;
  padding: 20px;
  background-color: #f0f7ff;
  padding: 50px;
  background-color: #f0f7ff;
  background-image: url("/assets/cablepro/img/Group9.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.logo {
  margin-bottom: 15px;
}

.right-content {
  width: 40%;
  height: 100%;
  position: relative;
  padding: 20px;
}

.separator {
  border-left: 1px solid #2f2f2f;
  height: 100vh;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
}

.center-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 95vh;
  width: 340px;
}

.center-content img {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
}

.maintext {
  font-family: "Open Sans", sans-serif !important;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  color: #3f474d;
}

.btn-group-vertical {
  width: 100%;
}

.btn-custom,
.btn-inline {
  background-color: #fff;
  border: 1px solid #2f2f2f;
  border-radius: 30px !important;
  width: 100%;
  margin-bottom: 15px;
  font-size: 12px;
  padding: 0.375rem 0.75rem !important;
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: 400;
  font-family: "Open Sans", sans-serif !important;
}

.btn-custom div {
  width: 65%;
  text-align: left;
}

.btn-custom span {
  vertical-align: middle;
  margin-left: 5px;
}

.btn-blue {
  background-color: #4285f4 !important;
  border: 1px solid #4285f4 !important;
  color: white !important;
}

.btn-custom:hover {
  background-color: #f4f5f8;
}

.btn-blue:hover {
  background-color: #71a4f6 !important;
}

.btn-inline {
  width: auto;
  padding: 5px 15px; /* Adjust padding for inline appearance */
  display: inline-block;
}

.full-height {
  height: 100%;
}

.position-relative {
  position: relative;
}

.header {
  font-size: 29px;
  margin-bottom: 10px;
  font-family: "Open Sans", sans-serif !important;
  font-weight: 600;
}

.line-text-20 {
  font-size: 20px;
  margin-bottom: 5px;
  font-family: "Open Sans", sans-serif !important;
}

.line-text-18 {
  font-size: 18px;
  margin-bottom: 5px;
  font-family: "Open Sans", sans-serif !important;
}

.line-text-15 {
  font-size: 15px;
  margin-bottom: 30px;
  font-family: "Open Sans", sans-serif !important;
}

.additional-buttons {
  text-align: center;
}

.additional-buttons span {
  margin-right: 10px;
  font-size: 12px;
  font-family: "Open Sans", sans-serif !important;
}

.additional-buttons button {
  margin-bottom: 0px;
}

.additional-buttons button:hover {
  background-color: #f4f5f8;
}

.register-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.register-form .control {
  width: 100%;
  margin-bottom: 10px;
}

.form-input {
  padding: 8px 12px;
  border: 1px solid #90a4ae;
  border-radius: 30px !important; /* Match the button border radius */
  background-color: #fff; /* Match the button background color */
  width: 100%;
  box-sizing: border-box;
  font-family: "Source Sans Pro", sans-serif !important;
  height: 52px;
  font-size: 18px;
  font-weight: 400;
  font-family: "Open Sans", sans-serif !important;
}

.control .checkboxstyle .login-controls {
  width: 100%;
  margin-top: 20px;
}

.login-with-email {
  margin-top: 20px;
  margin-bottom: 20px;
  display: block;
}

.signin-other-title {
  position: relative;
  width: 100%;
}

.signin-other-title .title {
  display: inline-block;
  position: relative;
  z-index: 9;
  background-color: #fff;
  padding: 20px;
  color: #90a4ae;
}

.signin-other-title:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  right: 0;
  border-top: 1px solid #90a4ae;
  top: 50%;
}

.text-section {
  text-align: left; /* Align text to the left */
  margin: 20px auto;
  /* max-width: 362px; */
}

.line-text {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 600;
}

.checked-list {
  list-style: none;
  margin-left: 15px;
}

.checked-list li {
  display: flex;
  align-items: flex-start;
  font-size: 18px; /* Adjust font size */
  font-family: "Open Sans", sans-serif !important;
  margin: 5px 0;
}

.wow {
  font-family: "Open Sans", sans-serif !important;
  font-size: 18px;
  margin-bottom: 20px;
}

.checked-list li i {
  color: #34a853;
  margin-right: 10px;
  font-size: 13px;
  margin-top: 3px; /* Align icon vertically with text */
}

.trusted-by {
  max-width: calc(20% - 40px); /* Adjust the number based on the number of images */
  height: auto; /* Maintain aspect ratio */
  flex: 1 1 auto;
}

:host ::ng-deep .form-control-feedback {
  font-size: 15px !important;
  padding: 0 10px;
}

.support-number a {
  color: #4285f4 !important;
  text-decoration: none;
}

.left-content-section {
  max-width: 845px;
}

.margin-top-30 {
  margin-top: 30px;
}

.company-imgs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
.company-imgs a {
  height: auto;
}

validation-messages {
  font-family: "Open Sans", sans-serif;
}

.help-block {
  color: #f4516c !important;
  font-family: "Open Sans", sans-serif !important;
}

.passwordmessage {
  font-size: 15px;
  padding: 0 10px;
}

.login-link {
  text-decoration: underline;
  margin-top: 10px;
  color: #4285f4;
  font-size: 15px;
}

.footer-area {
  background-color: white;
  width: 100%;
}

.footer-text {
  font-family: "Open Sans", sans-serif !important;
  font-size: 15px;
}

.default-color {
  color: #4285f4;
}

:host ::ng-deep .phone-number-input {
  border: 1px solid #90a4ae;
  border-radius: 30px !important; /* Match the button border radius */
  background-color: #fff; /* Match the button background color */
  width: 100%;
  box-sizing: border-box;
  font-family: "Source Sans Pro", sans-serif !important;
  height: 52px;
  font-size: 18px;
  font-weight: 400;
  font-family: "Open Sans", sans-serif !important;
}

:host ::ng-deep .iti {
  width: 100%;
}

:host ::ng-deep .iti__selected-flag {
  padding: 0px 6px 0 12px;
}

:host ::ng-deep .iti--allow-dropdown .iti__flag-container:hover .iti__selected-flag {
  background-color: transparent;
}

@media (max-height: 768px) {
  .register-image {
    width: 420px !important;
  }
}
@media (min-width: 768px) and (max-width: 1100px) {
  .register-image {
    width: 350px !important;
  }
  .trusted-by {
    max-width: calc(20% - 20px);
  }
}
@media (min-width: 768px) and (max-width: 900px) {
  .btn-custom div {
    width: 100%;
    text-align: center;
  }
}
@media (min-width: 1101px) and (max-width: 1600px) {
  .register-image {
    width: 450px !important;
  }
}
@media (max-width: 767px) {
  .left-content {
    display: none !important;
  }
  .full-height {
    height: auto !important;
  }
  .right-content,
  .right-text-only {
    width: 100%;
  }
  .right-text-only {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: flex-end !important;
    text-align: center !important;
    margin-bottom: 20px !important;
    order: 1;
    height: 100%;
  }
  .right-content {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    order: 2;
  }
  .image-box-container {
    display: none !important;
  }
  .position-relative {
    margin-top: 88px;
  }
  .mobile-hide {
    display: none;
  }
}
@media (max-width: 1250px) {
  .terms-privacy {
    display: block !important;
  }
}
.center-register-content-popup {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  height: auto !important;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/account/register/register.component.scss"],"names":[],"mappings":"AAGA;;;;;;;EAOI,+CAAA;EACA,cAAA;AAFJ;;AAKA;EACI,uBAAA;AAFJ;;AAKA;EACI,wBAAA;AAFJ;;AAKA;EACI,qDAAA;EACA,cAAA;AAFJ;;AAKA;;EAEI,wBAAA;EACA,mBAAA;EACA,uBAAA;AAFJ;;AAKA;EACI,UAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,yBAAA;EACA,wDAAA;EACA,4BAAA;EACA,sBAAA;AAFJ;;AAKA;EACI,mBAAA;AAFJ;;AAKA;EACI,UAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AAFJ;;AAKA;EACI,8BAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,2BAAA;AAFJ;;AAIA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;AADJ;;AAGA;EACI,eAAA;EACA,YAAA;EACA,sBAAA;AAAJ;;AAEA;EACI,+CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAlFgB;EAmFhB,cAAA;AACJ;;AACA;EACI,WAAA;AAEJ;;AAAA;;EAEI,sBAAA;EACA,yBAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eArGgB;EAsGhB,gBAAA;EACA,+CAAA;AAGJ;;AAAA;EACI,UAAA;EACA,gBAAA;AAGJ;;AAAA;EACI,sBAAA;EACA,gBAAA;AAGJ;;AAAA;EACI,oCAAA;EACA,oCAAA;EACA,uBAAA;AAGJ;;AAAA;EACI,yBAAA;AAGJ;;AAAA;EACI,oCAAA;AAGJ;;AAAA;EACI,WAAA;EACA,iBAAA,EAAA,yCAAA;EACA,qBAAA;AAGJ;;AADA;EACI,YAAA;AAIJ;;AAFA;EACI,kBAAA;AAKJ;;AAHA;EACI,eAAA;EACA,mBAAA;EACA,+CAAA;EACA,gBAAA;AAMJ;;AAJA;EACI,eAAA;EACA,kBAAA;EACA,+CAAA;AAOJ;;AALA;EACI,eAzJgB;EA0JhB,kBAAA;EACA,+CAAA;AAQJ;;AANA;EACI,eA7JkB;EA8JlB,mBAAA;EACA,+CAAA;AASJ;;AANA;EACI,kBAAA;AASJ;;AAPA;EACI,kBAAA;EACA,eAAA;EACA,+CAAA;AAUJ;;AAPA;EACI,kBAAA;AAUJ;;AAPA;EACI,yBAAA;AAUJ;;AAPA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAUJ;;AAPA;EACI,WAAA;EACA,mBAAA;AAUJ;;AAPA;EACI,iBAAA;EACA,yBAAA;EACA,8BAAA,EAAA,mCAAA;EACA,sBAAA,EAAA,sCAAA;EACA,WAAA;EACA,sBAAA;EACA,qDAAA;EACA,YAAA;EACA,eAxMgB;EAyMhB,gBAAA;EACA,+CAAA;AAUJ;;AAPA;EACI,WAAA;EACA,gBAAA;AAUJ;;AAPA;EACI,gBAAA;EACA,mBAAA;EACA,cAAA;AAUJ;;AAPA;EACI,kBAAA;EACA,WAAA;AAUJ;;AAPA;EACI,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;AAUJ;;AAPA;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,6BAAA;EACA,QAAA;AAUJ;;AAPA;EACI,gBAAA,EAAA,2BAAA;EACA,iBAAA;EACA,sBAAA;AAUJ;;AAPA;EACI,mBAAA;EACA,eAzPgB;EA0PhB,gBAAA;AAUJ;;AAPA;EACI,gBAAA;EACA,iBAAA;AAUJ;;AAPA;EACI,aAAA;EACA,uBAAA;EACA,eArQgB,EAqQe,qBAAA;EAC/B,+CAAA;EACA,aAAA;AAUJ;;AAPA;EACI,+CAAA;EACA,eA5QgB;EA6QhB,mBAAA;AAUJ;;AAPA;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA,EAAA,oCAAA;AAUJ;;AAPA;EACI,2BAAA,EAAA,oDAAA;EACA,YAAA,EAAA,0BAAA;EACA,cAAA;AAUJ;;AAPA;EACI,0BAAA;EACA,eAAA;AAUJ;;AAPA;EACI,yBAAA;EACA,qBAAA;AAUJ;;AAPA;EACI,gBAAA;AAUJ;;AAPA;EACI,gBAAA;AAUJ;;AAPA;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AAUJ;AARI;EACI,YAAA;AAUR;;AANA;EACI,oCAAA;AASJ;;AANA;EACI,yBAAA;EACA,+CAAA;AASJ;;AANA;EACI,eAAA;EACA,eAAA;AASJ;;AANA;EACI,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,eA5UkB;AAqVtB;;AANA;EACI,uBAAA;EACA,WAAA;AASJ;;AANA;EACI,+CAAA;EACA,eAtVkB;AA+VtB;;AANA;EACI,cAAA;AASJ;;AANA;EACI,yBAAA;EACA,8BAAA,EAAA,mCAAA;EACA,sBAAA,EAAA,sCAAA;EACA,WAAA;EACA,sBAAA;EACA,qDAAA;EACA,YAAA;EACA,eAtWgB;EAuWhB,gBAAA;EACA,+CAAA;AASJ;;AANA;EACI,WAAA;AASJ;;AANA;EACI,uBAAA;AASJ;;AANA;EACI,6BAAA;AASJ;;AALA;EACI;IACI,uBAAA;EAQN;AACF;AALA;EACI;IACI,uBAAA;EAON;EALE;IACI,2BAAA;EAON;AACF;AAJA;EACI;IACI,WAAA;IACA,kBAAA;EAMN;AACF;AAHA;EACI;IACI,uBAAA;EAKN;AACF;AAFA;EACI;IACI,wBAAA;EAIN;EAFE;IACI,uBAAA;EAIN;EAFE;;IAEI,WAAA;EAIN;EADE;IACI,wBAAA;IACA,iCAAA;IACA,8BAAA;IACA,oCAAA;IACA,6BAAA;IACA,8BAAA;IACA,QAAA;IACA,YAAA;EAGN;EADE;IACI,wBAAA;IACA,iCAAA;IACA,8BAAA;IACA,kCAAA;IACA,QAAA;EAGN;EAAE;IACI,wBAAA;EAEN;EACE;IACI,gBAAA;EACN;EACE;IACI,aAAA;EACN;AACF;AAEA;EACI;IACI,yBAAA;EAAN;AACF;AAIA;EACI,wBAAA;EACA,iCAAA;EACA,8BAAA;EACA,kCAAA;EACA,uBAAA;EACA,WAAA;AAFJ","sourcesContent":["$primary-font-size: 18px;\n$secondary-font-size: 15px;\n\ninput,\noptgroup,\nselect,\ntextarea,\nlabel,\na,\np {\n    font-family: \"Open Sans\", sans-serif !important;\n    color: #2f2f2f;\n}\n\n.register-container {\n    background-color: white;\n}\n\n.register-container .d-flex {\n    display: flex !important;\n}\n\nbutton {\n    font-family: \"Source Sans Pro\", sans-serif !important;\n    color: #2f2f2f;\n}\n\n.left-content,\n.right-content {\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n}\n\n.left-content {\n    width: 60%;\n    position: relative;\n    padding: 20px;\n    background-color: #f0f7ff;\n    padding: 50px;\n    background-color: #f0f7ff;\n    background-image: url(\"/assets/cablepro/img/Group9.png\");\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n\n.logo {\n    margin-bottom: 15px;\n}\n\n.right-content {\n    width: 40%;\n    height: 100%;\n    position: relative;\n    padding: 20px;\n}\n\n.separator {\n    border-left: 1px solid #2f2f2f;\n    height: 100vh;\n    position: absolute;\n    left: 50%;\n    top: 0;\n    transform: translateX(-50%);\n}\n.center-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 95vh;\n    width: 340px;\n}\n.center-content img {\n    max-width: 100%;\n    height: auto;\n    vertical-align: middle;\n}\n.maintext {\n    font-family: \"Open Sans\", sans-serif !important;\n    font-style: normal;\n    font-weight: 600;\n    font-size: $primary-font-size;\n    color: #3f474d;\n}\n.btn-group-vertical {\n    width: 100%;\n}\n.btn-custom,\n.btn-inline {\n    background-color: #fff;\n    border: 1px solid #2f2f2f;\n    border-radius: 30px !important;\n    width: 100%;\n    margin-bottom: 15px;\n    font-size: 12px;\n    padding: 0.375rem 0.75rem !important;\n    height: 52px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: $primary-font-size;\n    font-weight: 400;\n    font-family: \"Open Sans\", sans-serif !important;\n}\n\n.btn-custom div {\n    width: 65%;\n    text-align: left;\n}\n\n.btn-custom span {\n    vertical-align: middle;\n    margin-left: 5px;\n}\n\n.btn-blue {\n    background-color: #4285f4 !important;\n    border: 1px solid #4285f4 !important;\n    color: white !important;\n}\n\n.btn-custom:hover {\n    background-color: #f4f5f8;\n}\n\n.btn-blue:hover {\n    background-color: #71a4f6 !important;\n}\n\n.btn-inline {\n    width: auto;\n    padding: 5px 15px; /* Adjust padding for inline appearance */\n    display: inline-block;\n}\n.full-height {\n    height: 100%;\n}\n.position-relative {\n    position: relative;\n}\n.header {\n    font-size: 29px;\n    margin-bottom: 10px;\n    font-family: \"Open Sans\", sans-serif !important;\n    font-weight: 600;\n}\n.line-text-20 {\n    font-size: 20px;\n    margin-bottom: 5px;\n    font-family: \"Open Sans\", sans-serif !important;\n}\n.line-text-18 {\n    font-size: $primary-font-size;\n    margin-bottom: 5px;\n    font-family: \"Open Sans\", sans-serif !important;\n}\n.line-text-15 {\n    font-size: $secondary-font-size;\n    margin-bottom: 30px;\n    font-family: \"Open Sans\", sans-serif !important;\n}\n\n.additional-buttons {\n    text-align: center;\n}\n.additional-buttons span {\n    margin-right: 10px;\n    font-size: 12px;\n    font-family: \"Open Sans\", sans-serif !important;\n}\n\n.additional-buttons button {\n    margin-bottom: 0px;\n}\n\n.additional-buttons button:hover {\n    background-color: #f4f5f8;\n}\n\n.register-form {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.register-form .control {\n    width: 100%;\n    margin-bottom: 10px;\n}\n\n.form-input {\n    padding: 8px 12px;\n    border: 1px solid #90a4ae;\n    border-radius: 30px !important; /* Match the button border radius */\n    background-color: #fff; /* Match the button background color */\n    width: 100%;\n    box-sizing: border-box;\n    font-family: \"Source Sans Pro\", sans-serif !important;\n    height: 52px;\n    font-size: $primary-font-size;\n    font-weight: 400;\n    font-family: \"Open Sans\", sans-serif !important;\n}\n\n.control .checkboxstyle .login-controls {\n    width: 100%;\n    margin-top: 20px;\n}\n\n.login-with-email {\n    margin-top: 20px;\n    margin-bottom: 20px;\n    display: block;\n}\n\n.signin-other-title {\n    position: relative;\n    width: 100%;\n}\n\n.signin-other-title .title {\n    display: inline-block;\n    position: relative;\n    z-index: 9;\n    background-color: #fff;\n    padding: 20px;\n    color: #90a4ae;\n}\n\n.signin-other-title:after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 1px;\n    left: 0;\n    right: 0;\n    border-top: 1px solid #90a4ae;\n    top: 50%;\n}\n\n.text-section {\n    text-align: left; /* Align text to the left */\n    margin: 20px auto;\n    /* max-width: 362px; */\n}\n\n.line-text {\n    margin-bottom: 10px;\n    font-size: $primary-font-size;\n    font-weight: 600;\n}\n\n.checked-list {\n    list-style: none;\n    margin-left: 15px;\n}\n\n.checked-list li {\n    display: flex;\n    align-items: flex-start;\n    font-size: $primary-font-size; /* Adjust font size */\n    font-family: \"Open Sans\", sans-serif !important;\n    margin: 5px 0;\n}\n\n.wow {\n    font-family: \"Open Sans\", sans-serif !important;\n    font-size: $primary-font-size;\n    margin-bottom: 20px;\n}\n\n.checked-list li i {\n    color: #34a853;\n    margin-right: 10px;\n    font-size: 13px;\n    margin-top: 3px; /* Align icon vertically with text */\n}\n\n.trusted-by {\n    max-width: calc(100% / 5 - 40px); /* Adjust the number based on the number of images */\n    height: auto; /* Maintain aspect ratio */\n    flex: 1 1 auto;\n}\n\n:host ::ng-deep .form-control-feedback {\n    font-size: $secondary-font-size !important;\n    padding: 0 10px;\n}\n\n.support-number a {\n    color: #4285f4 !important;\n    text-decoration: none;\n}\n\n.left-content-section {\n    max-width: 845px;\n}\n\n.margin-top-30 {\n    margin-top: 30px;\n}\n\n.company-imgs {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    justify-content: center;\n    align-items: center;\n\n    a {\n        height: auto;\n    }\n}\n\nvalidation-messages {\n    font-family: \"Open Sans\", sans-serif;\n}\n\n.help-block {\n    color: #f4516c !important;\n    font-family: \"Open Sans\", sans-serif !important;\n}\n\n.passwordmessage {\n    font-size: 15px;\n    padding: 0 10px;\n}\n\n.login-link {\n    text-decoration: underline;\n    margin-top: 10px;\n    color: #4285f4;\n    font-size: $secondary-font-size;\n}\n\n.footer-area {    \n    background-color: white;\n    width: 100%;\n}\n\n.footer-text {\n    font-family: \"Open Sans\", sans-serif !important;\n    font-size: $secondary-font-size;\n}\n\n.default-color {\n    color: #4285f4;\n}\n\n:host ::ng-deep .phone-number-input {\n    border: 1px solid #90a4ae;\n    border-radius: 30px !important; /* Match the button border radius */\n    background-color: #fff; /* Match the button background color */\n    width: 100%;\n    box-sizing: border-box;\n    font-family: \"Source Sans Pro\", sans-serif !important;\n    height: 52px;\n    font-size: $primary-font-size;\n    font-weight: 400;\n    font-family: \"Open Sans\", sans-serif !important;\n}\n\n:host ::ng-deep .iti{\n    width: 100%;\n}\n\n:host ::ng-deep .iti__selected-flag {\n    padding: 0px 6px 0 12px;\n}\n\n:host ::ng-deep .iti--allow-dropdown .iti__flag-container:hover .iti__selected-flag {\n    background-color: transparent;\n}\n\n\n@media (max-height: 768px) {\n    .register-image {\n        width: 420px !important;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 1100px) {\n    .register-image {\n        width: 350px !important;\n    }\n    .trusted-by {\n        max-width: calc(100% / 5 - 20px);\n    }\n}\n\n@media (min-width: 768px) and (max-width: 900px) {\n    .btn-custom div {\n        width: 100%;\n        text-align: center;\n    }\n}\n\n@media (min-width: 1101px) and (max-width: 1600px) {\n    .register-image {\n        width: 450px !important;\n    }\n}\n\n@media (max-width: 767px) {\n    .left-content {\n        display: none !important;\n    }\n    .full-height {\n        height: auto !important;\n    }\n    .right-content,\n    .right-text-only {\n        width: 100%;\n    }\n\n    .right-text-only {\n        display: flex !important;\n        flex-direction: column !important;\n        align-items: center !important;\n        justify-content: flex-end !important;\n        text-align: center !important;\n        margin-bottom: 20px !important;\n        order: 1;\n        height: 100%;\n    }\n    .right-content {\n        display: flex !important;\n        flex-direction: column !important;\n        align-items: center !important;\n        justify-content: center !important;\n        order: 2;\n    }\n\n    .image-box-container {\n        display: none !important;\n    }\n\n    .position-relative {\n        margin-top: 88px;\n    }\n    .mobile-hide {\n        display: none;\n    }\n}\n\n@media (max-width: 1250px) {\n    .terms-privacy {\n        display: block !important;\n    }\n}\n\n\n.center-register-content-popup {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: center !important;\n    justify-content: center !important;\n    height: auto !important;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
